import DonutChart from "../../components/charts/DonutChart";
import ColumnChart from "../../components/charts/ColumnChart";
import ProgressBar from "../../components/charts/ProgressBar";
import LineChart from "../../components/charts/LineChart";
import { useFetchProjects } from "../../hooks/api/projects/projects";
import { useEffect, useState } from "react";
import { useFetchCompletionTrend, useFetchManageReport, useFetchProgress } from "../../hooks/api/dashboard/dashboard";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { formatTrendForApexChart } from "./helper";
import CompletionTrendChart from "./components/CompletionTrend";

const AdminSummary = () =>{
    const [filters, setFilters]= useState({
        orgId:"",
        projectId:""
    })
    const fetchProjects= useFetchProjects(filters)
    const fetchProgress= useFetchProgress(filters)
    const fetchCompletionTrend= useFetchCompletionTrend(filters)
    // const fetchManageReport= useFetchManageReport(filters)
   
    const date= new Date();
    const today= date.toLocaleString('en-us');

    useEffect(()=>{

      // formatTrendForApexChart(fetchCompletionTrend?.data?.trends, "trends")
        const apexChartOptions = formatTrendForApexChart(fetchCompletionTrend?.data?.trends);
        console.log(apexChartOptions, "trednd");
    },[fetchCompletionTrend.data])

    const groupsAndData= {
        LPA: {
            name: 'LPA Group Summary',
            cat: ['Lagos', 'Rivers', 'Abuja'],
            data: [50, 85, 55]
        },
        group2: {
            name: 'Group 2 Summary',
            cat: ['Anambra', 'Delta', 'Edo', 'Akwa-Ibom', 'Bayelsa', 'Cross-River', 'Abia'],
            data: [40, 50, 55, 73, 44, 34, 67]
        },
    }

    return (
        <div className="flex flex-col w-full h-max bg-slate-100 p-4 items-center justify-start shadow">
            <h1>Admin Summary</h1>

<div className="" style={{alignSelf:"flex-start"}}>
    <p>Select Project</p>
    <select name="" id="" onChange={e=>setFilters(prev=>({...prev, projectId:e.target.value}))}>
        <option value="">Select</option>
{fetchProjects.data?.projects?.map(project=><option value={project?.id}>{project?.name}</option>)}
  </select>
</div>

{/* 
            <section className="w-full h-max m-5 p-2 shadow border border-slate-200">
                <h1 className="self-start font-bold text-xl">Campaign Progress</h1>
                <ProgressBar progressPercentage={60} />
            </section>

            <section className="w-full p-5 m-4 bg-white shadow-md rounded-lg">
                <h1 className="self-start font-bold text-xl">Scope Completion (Daily)</h1>
                <p className="text-slate-600">Date: <span className="text-slate-400">{today}</span></p>
                <div className="flex flex-wrap p-6 w-full h-max justify-center">
                    <DonutChart data={[60, 100-60]} titleText={'LPA Group'} />
                    <DonutChart data={[60, 100-60]} titleText={'Group 2 '} />
                    <DonutChart data={[60, 100-60]} titleText={'Group 3 '} />
                </div>
            </section> */}

            {/* <section className="w-full p-5 m-4 bg-white shadow-md rounded ">
                <h1 className="self-start font-bold text-xl">Project Scope Completion (Groups)</h1>
                <div className="flex flex-wrap self-start w-full p-6">
                    <div className="w-1/3 h-max pt-4 m-2 shadow-md">
                        <ColumnChart
                        data={[70, 80, 60]} 
                        xaxis={['LPA', 'Group 1', 'Group 2']} 
                        titleText={'Group Progress Summary'} 
                        horizontal={true}
                        />
                    </div>
                    <div className="w-3/5 h-max pt-4 m-2 shadow-md">
                        <ColumnChart
                        data={groupsAndData.group2.data} 
                        xaxis={groupsAndData.group2.cat} 
                        titleText={groupsAndData.group2.name} 
                        horizontal={false}
                        />
                    </div>
                </div>
            </section> */}
            
            {/* <section className="w-full p-5 m-4 bg-white shadow-md rounded ">
                <h1 className="self-start font-bold text-xl">Best and Worst Performers</h1>
                <div className="flex flex-wrap self-center justify-content-center w-full p-6">
                    <div className="w-2/5 h-max pt-4 m-2 shadow-md">
                        <ColumnChart
                        data={[98, 97, 97, 96, 96]} 
                        xaxis={['Abigail SS0345', 'Sheriff SE4367', 'Joshua SS3433', 'Temi SW3439', 'Uche SE3789']} 
                        titleText={'Top 5 performers'} 
                        horizontal={false}
                        />
                    </div>
                    <div className="w-2/5 h-max pt-4 m-2 shadow-md">
                        <ColumnChart
                        data={[25, 26, 34, 36, 36]} 
                        xaxis={['Diirin SW0345', 'Mopol SE7367', 'Keshia SS3833', 'Tefiama SW3939', 'Ogbo SE3009']} 
                        titleText={'Bottom 5 performers'} 
                        horizontal={false}
                        />
                    </div>
                </div>
            </section> */}

            <section className="w-full p-5 m-4 bg-white shadow-md rounded ">
                <h1 className="self-start font-bold text-xl">Progress Summary</h1>
                <div className="stats shadow p-4 rounded-sm max-w-sm my-2">
  <div className="stat  ">
    <div className="stat-title text-2xl font-semibold">Overall</div>
    <div className="stat-value text-lg">Assigned: {fetchProgress?.data?.overall?.assigned}</div>
    <div className="stat-desc text-lg">Completed: {fetchProgress?.data?.overall?.completed}</div>
  </div>
 
</div>
               { fetchProgress.data?.progress?.length>0?
               <ColumnChart
              //  series
                        data={fetchProgress?.data?.progress?.map(item=>Number(item?.progress)) } 
                        xaxis={fetchProgress?.data?.progress?.map(item=>item?.date)} 
                        titleText={'Progress'} 
                        horizontal={false}
                        />:<p>No data</p>}

                    </section>
            <section className="w-full p-5 m-4 bg-white shadow-md rounded ">
                <h1 className="self-start font-bold text-xl">Completion Trend</h1>
                


               { fetchCompletionTrend.data?.trends?.length>0?

<div className="">
{/* <ReactApexChart
  options={formatTrendForApexChart(fetchCompletionTrend?.data?.trends)}
  series={formatTrendForApexChart(fetchCompletionTrend?.data?.trends).series}
  type="bar"
  width="100%" // Makes the chart responsive
  height={400}
/> */}

<CompletionTrendChart data={fetchCompletionTrend.data}/>
</div>
:null}  


             

                    </section>
            
        </div>
    )
};

export default AdminSummary;